import moment from 'moment';
import { Epic, combineEpics } from 'redux-observable';
import * as api from '../api';
import { StoreState, SchoolSession, SESSION_STATUS_PLANNED, SESSION_STATUS_COMPLETED } from '../types';
import { createTryActionsEpic } from './Common';
import { MoveSessions } from '../api/Commands';
import { SAVE_SESSION, MOVE_SESSIONS, SchoolSessionAction } from '../actions/SchoolSessionActions';

const saveSession = async (s: SchoolSession) => {
    const today = moment();
    const command = {
        sessionId: s.sessionId,
        schoolId: s.schoolId,
        instructorEmails: s.instructorEmails,
        activity: s.activity,
        format: s.format,
        type: s.type,
        start: s.start,
        durationHours: s.durationHours,
        completedHours: s.completedHours || 0,
        members: s.bookingMembers.map(bm => ({
            bookingId: bm.bookingId,
            memberEmail: bm.memberEmail,
            memberName: bm.memberName
        })),
        spot: s.spot || null,
        comments: s.comments || '',
        status: s.status || (moment(s.start).isBefore(today, 'days') ? SESSION_STATUS_PLANNED : SESSION_STATUS_COMPLETED)
    };

    return command.sessionId
        ? await api.updateSession(command)
        : await api.createSession(command);
};

const moveSessions = async (command: MoveSessions) => {
    if (!command.schoolId) {
        throw new Error('moveSessions schoolId missing');
    }
    if (!command.sessionIds || command.sessionIds.length === 0) {
        throw new Error('moveSessions sessionIds missing');
    }
    if (!command.laterByHours) {
        throw new Error('moveSessions laterByHours missing');
    }
    return await api.moveSessions(command);
};

const saveSessionEpic: Epic<SchoolSessionAction, SchoolSessionAction, StoreState> =
    createTryActionsEpic(
        SAVE_SESSION,
        (a) => saveSession(a.value),
        (a) => a.value);

const moveSessionsEpic: Epic<SchoolSessionAction, SchoolSessionAction, StoreState> =
    createTryActionsEpic(
        MOVE_SESSIONS,
        (a) => moveSessions(a.value),
        (a) => a.value);

export default combineEpics<SchoolSessionAction, SchoolSessionAction, StoreState>(
    saveSessionEpic,
    moveSessionsEpic,
);
